import { Injectable } from '@angular/core';
import { ICDSConfig } from '../interfaces/icdsconfig';
import { ICDS, ICDSChange } from '../interfaces/icds';
import { CdsMetadata } from '../class/cds-metadata';
import { BehaviorSubject, Observable } from 'rxjs';
import { CDSMetadata } from '../class/CDSMetadata';

export interface IResponseCollection {
	[key: string]: any
}

export interface ICall {
	metadata: CdsMetadata | CDSMetadata,
	response: any
}


export interface IActiveRequest {
	[key: string]: IRequest
}

export interface IRequest {
	[key: string]: ICall
}

@Injectable({
	providedIn: 'root'
})
export class CdsStoreService {

	request: BehaviorSubject<ICDSChange>;
	stream$: Observable<ICDSChange>;
	configStore = new Map<string, ICDSConfig>();


	constructor() {
		this.request = new BehaviorSubject<ICDSChange>({
			store: {},
			patch: { key: '', id: '' }
		} as ICDSChange);
		this.stream$ = this.request.asObservable();
	}
	/**
	 * Cds Config 
	*/
	CDSConfig: ICDSConfig;
	currentConfigStoreId: string;

	/**
	 * metadata recevied when initial loading of the app will be saved here
	 */
	MetadataCollection: ICDS = {};

	activateStore(storeId: string) {
		this.currentConfigStoreId = storeId;
		this.CDSConfig = this.configStore.get(storeId);
	}


	/**
	 * Active Requests 
	*/

	ActiveRequests: IActiveRequest = {};
	/* 
		TODO:FIGURE out a way to associate the endpoint with store and use that to drop endponts from active requests when cds config is dropped.
	*/

	/**
	 * maximum cached calls per API
	 */
	MaximumCalls = 10;

	reset(storeId?: string) {
		this.CDSConfig = null;
	}
}
